import { SocialProviderId } from "../config";

export enum SocialType {
  Post = 1,
  Story = 2,
}

export interface PostError {
  type: PostErrorType;
  message?: string;
  socialProviderId: SocialProviderId;
  linkText?: string;
  link?: string;
}

export enum PostErrorType {
  MediaRequired,
  TextSize,
  VideoNotAllowed,
  /** p. ej. TikTok: solo video */
  ImageNotAllowed,
  ImageAspectRatio,
  ImageAspectRatioSize,
  VideoAspectRatioSize,
  MaxImagesPerPost,
  MaxVideoSize,
  MaxImageSize,
  MaxVideoDuration,
}

export interface SocialPostRules {
  maxVideoSize: number;
  maxImageSize: number,
  maxCharactersAllowed: number;
  maxPostPhotoAllowed: number;
  videoAllowed: boolean;
  /** Si es false, no se puede adjuntar imágenes (p. ej. TikTok solo video). Por defecto true. */
  imageAllowed?: boolean;
  postMediaRequired: boolean;
  maxStoryPhotoAllowed?: number;
  storyMediaRequired?: boolean;
  maxVideoDuration?: number;
  imageAspectRatioSizeAllowed?: number[];
  videoAspectRatioSizeAllowed?: number[];
  imageAspectRatioAllowed?: string[];
  maxHashtagsAllowed?: number;
}
